module.exports = __webpack_public_path__ + "img/personPlan.d686e6e7.svg";